import { parse } from "date-fns";

import { IReplyAddress } from "store/entities/reply-addresses/interfaces";

export default abstract class ReplyAddressSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }): IReplyAddress {
    const deserialized: IReplyAddress = {
      id: data.ID,
      licenseID: data.licenseID,
      email: data.email,
      verified: data.verified,
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      createdByType: data.createdByType,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      emailDomainID: data.emailDomainID,
      prefix: data.prefix,
    };
    return deserialized;
  }
}
